import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const resources = {
  en: {
    translation: {
      'common.back': 'Back',
      'common.delete': 'Delete',
      'common.apply': 'Apply',
      'common.ok': 'OK',
      'common.close': 'Close',
      'common.error': 'Error',
      'common.success': 'Success',
      'common.warning': 'Warning',
      'common.information': 'Information',
      'common.copy': 'Copy',
      'common.copyToClipboard': 'Was copied to clipboard',
      'common.reset': 'Reset',
      'common.approve': 'Approve',
      'common.loading': 'Loading ...',
      'common.loadMore': 'Load more',
      'common.send': 'Send',
      'common.slogan': 'Easy electronic check management',
      'common.logout': 'Log out',
      'common.termsAgreement': 'I agree to ',
      'common.termsAndConditions': 'Terms and Conditions',
      'common.note': 'Note',
      'common.archive': 'Archive',
      'common.all': 'All',
      'common.activate': 'Activate',
      'common.selectNoOptions': 'No options available',

      'common.emptyState': 'No items found',
      'common.emptyState.clearFilters': 'Clear filters',
      'common.emptyState.description':
        'There are no items to display at the moment. \nTry adjusting your filters or check back later.',

      // user menu
      'menu.home': 'Home',
      'menu.myPayments': 'My payments',
      'menu.myPayees': 'My payees',
      'menu.userPayees': 'My Payees',
      'menu.allPayees': 'Payees',
      'menu.allPayments': 'Payments',
      'menu.banks': 'Banks',
      'menu.settings': 'Settings',
      'menu.audit': 'Audit History',
      'menu.logOut': 'Log out',
      'menu.profile': 'Profile',
      'menu.tour': 'App Tour',

      // empty
      'common.empty.header': 'This page is under development',
      'common.empty.subHeader': 'This is empty sub header',

      // common navigation
      'common.navigation.backToLogin': 'Back to login',

      // navigation support
      'navigation.support.helpAndLegal': 'Help & Legal',
      'navigation.support.helpAndSupport': 'Help & Support',
      'navigation.support.disclaimer': 'Disclaimer',
      'navigation.support.privacyPolicy': 'Privacy Policy',
      'navigation.support.termsAndConditions': 'Terms & Conditions',

      // forms
      'common.form.email.label': 'email',
      'common.form.email.placeholder': 'Enter email address',
      'common.form.email.error.invalid': 'Invalid Email Address',
      'common.form.email.notFoundText': 'No email found',
      'common.form.emptyFieldError': 'This field is required',

      'common.form.password.label': 'Password',
      'common.form.password.placeholder': 'Enter Password',
      'common.form.password.hint':
        '{{minLength}} characters minimum, case sensitive.',
      'common.form.save': 'Save',
      'common.form.invite': 'Invite',
      'common.form.request': 'Request',
      'common.form.saveAsDraft': 'Draft',
      'common.form.cancel': 'Cancel',
      'common.form.deleteConfirm': 'Are you sure you want to delete this item?',
      'common.form.confirm': 'Confirm',
      'common.form.fieldRequired': 'This field is required',
      'common.form.enterValueFor': 'Enter value for ',
      'common.form.invalidCheckNumber':
        'Check number must be a whole number (0 or greater)',
      'common.form.enterValueTo': 'Enter value to ',
      'common.form.typeToSearchValueFor': 'Search value for ',

      'common.typeahead.notFound': 'Not Found',
      'common.typeahead.nothingFound': 'Nothing Found',
      'common.typeahead.create': 'Create',
      'common.typeahead.noMatchingUser': 'No matching user',

      // avatar
      'avatar.upload': 'Upload',
      'avatar.change': 'Save',
      'avatar.zoom': 'Zoom',
      'avatar.rotation': 'Rotation',
      'avatar.rotate': 'Rotate',
      'avatar.save': 'Save Avatar',
      'avatar.open': 'Open file for avatar',

      // user profile
      'userProfile.header': 'User Profile',
      'userProfile.subHeader': 'Here you can see and edit your profile details',
      'userProfile.password.header': 'Change Password',
      'userProfile.password.subHeader':
        'You can change your account password here',
      'userProfile.firstName': 'First Name',
      'userProfile.lastName': 'Last Name',
      'userProfile.email': 'Email',
      'userProfile.phone': 'Phone',
      'userProfile.changePassword': 'Change Password',
      'userProfile.currentPassword': 'Current Password',
      'userProfile.newPassword': 'New Password',
      'userProfile.confirmPassword': 'Confirm Your New Password',
      'userProfile.changePassword.header': 'Change Password',
      'userProfile.changePassword.subHeader':
        'Please enter your new password and confirm it below',
      'userProfile.changePassword.passwordsDoNotMatch':
        'Passwords do not match',
      'userProfile.changePassword.error':
        'Error changing password. Please check your current password is correct',
      'userProfile.changePassword.success': 'Password changed successfully',

      // table
      'table.columnVisibility': 'Column visibility',
      'table.settings': 'Table Settings',
      'table.empty': 'There are no items to display',
      'table.loadMore': 'Load more',
      'table.delete': 'Delete',
      'table.json': 'JSON preview',
      'table.edit': 'Edit',
      'table.download': 'Download',
      'table.resend': 'Resend',
      'table.approve': 'Approve',
      'table.clearFilters': 'Clear filters',
      'table.addNew': 'Add new',
      'table.showFilters': 'Show filters',
      'table.hideFilters': 'Hide filters',
      'table.export': 'Export',
      'table.saveTableState': 'Save Table State',
      'table.clearTableFilterState': 'Clear Table Filter State',
      'table.copy': 'Copy',
      'table.copied': 'Copied!',

      // filter operators - string
      'filter.clear': 'Clear Filter',
      'filter.string.contains': 'Contains',
      'filter.string.equals': 'Equals',
      'filter.string.notEquals': 'Not Equals',
      'filter.string.startsWith': 'Starts With',
      'filter.string.endsWith': 'Ends With',
      'filter.string.notContains': 'Not Contains',

      // filter operators - numeric
      'filter.numeric.equals': 'Equals',
      'filter.numeric.notEquals': 'Not Equals',
      'filter.numeric.greaterThan': 'Greater Than',
      'filter.numeric.greaterThanOrEqual': 'Greater Than or Equal',
      'filter.numeric.lessThan': 'Less Than',
      'filter.numeric.lessThanOrEqual': 'Less Than or Equal',
      'filter.numeric.between': 'Between',
      'filter.numeric.inRange': 'In Range',

      'filter.date.equals': 'Equals',
      'filter.date.notEquals': 'Not Equals',
      'filter.date.greaterThan': 'Greater Than',
      'filter.date.greaterThanOrEqual': 'Greater Than or Equal',
      'filter.date.lessThan': 'Less Than',
      'filter.date.lessThanOrEqual': 'Less Than or Equal',
      'filter.date.between': 'Between',
      'filter.date.inRange': 'In Range',

      // common errors
      'errors.fields.fieldLongerThen': 'Field is longer than',
      'errors.fields.characters': 'characters',
      'errors.fields.emptyFieldError': "Field can't be empty",

      // login form
      'login.header': 'Login into account',
      'login.subHeader': 'Enter your email and password to your account',
      'login.signIn': 'Sign in',
      'login.register': 'Register',
      'login.forgotPassword': 'Forgot password?',
      'login.continueWith': 'or continue with',
      'login.invalidCredentials': 'Invalid email or password',
      'login.terms':
        'By clicking continue, you agree to our Terms of Service and Privacy Policy.',

      // forgot password form
      'forgotPassword.header': 'Forgot Your Password?',
      'forgotPassword.subHeader':
        'Enter your email address to receive a password reset link',
      'forgotPassword.fields.email': 'Email',
      'forgotPassword.sendResetEmail': 'Send reset link',
      'forgotPassword.emailSent.header': 'Password Reset Submitted',
      'forgotPassword.emailSent.subHeader':
        'If we have an account matching your email address, you will receive an email to reset your password.',
      'forgotPassword.genericError': 'Error sending password reset link',

      // reset password form
      'resetPassword.header': 'Create New Password',
      'resetPassword.subHeader': 'Enter your new password',
      'resetPassword.completed.header': 'Password Reset Completed',
      'resetPassword.completed.subHeader':
        'You can now log in with your new password.',
      'resetPassword.confirm': 'Confirm',
      'resetPassword.invalidTokenOrEmail': 'Invalid token or email',

      'register.header': 'User Registration',
      'register.subHeader':
        'Enter your email and password to register your account',
      'register.fields.firstName': 'First Name',
      'register.fields.lastName': 'Last Name',
      'register.fields.email': 'Email',
      'register.fields.password': 'Password',
      'register.fields.confirmPassword': 'Confirm Password',
      'register.genericError': 'Error registering user',
      'register.error.passwordNotSame': 'The passwords should be the same',
      'register.success': 'User registered successfully',
      'register.terms':
        'By clicking register, you agree to our Terms of Service and Privacy Policy.',

      // print echeck
      'printECheck.header': 'Print your e-check',
      'printECheck.printing': 'Printing document',
      'printECheck.checkPrintedHeader': 'The check has been printed',
      'printECheck.checkPrintedInfo': 'You can now close this window',
      'printECheck.subHeader': `Please print your e-check on check paper or plain white paper. The number of times this e-check can be printed is limited and determined by the sender's settings.`,
      'printECheck.amount': 'Amount: ',
      'printECheck.dateIssued': 'Issued Date: ',
      'printECheck.onWhitePaper': 'Print on white paper',
      'printECheck.onCheckPaper': 'Print on check paper',
      'emptyECheckBlank.download': '  Download Blank',
      'emptyECheckBlank.whitePaper': 'White paper blank',
      'emptyECheckBlank.checkPaper': 'Check blank',
      'printECheck.allowPopupsMessage':
        'To print the check, please allow pop-ups from this site. You can do this by going to your browser settings and selecting',
      'printECheck.alwaysAllowPopups': "'Always allow pop-ups from this site'",
      'printECheck.error': 'Error printing echeck',
      'printECheck.printing.endTitle': 'How was you printing experience?',
      'printECheck.printing.endText':
        'if it was successful, please click confirm, if not cancel',
      'printECheck.aboutInfo':
        "Our checks work just like regular checks. The Bank Account must be verified for the sender to use this feature. However, we are not a bank and do not hold the check's funds. If you have printed the check on white paper, you may notice that the check is printed upside down.",
      'printECheck.printing.error':
        'Error printing echeck. Please try again or contact support.',

      // Common Scams
      'commonScams.header': 'Common Scams',
      'commonScams.subHeader':
        'Each scam involving a fraudulent check may be different, but some of the more common scenarios are:',
      'commonScams.sellingGoods.title': 'Selling Goods',
      'commonScams.sellingGoods.description':
        'You sell products in the marketplace, for example, over the Internet. A buyer sends you a check for the price you agreed on, and you ship the goods to the buyer. The check turns out to be fraudulent.',

      'commonScams.excessPurchase.title': 'Excess of the Purchase Price',
      'commonScams.excessPurchase.description':
        'This scenario is similar to the one described above. However, the buyer sends you a check for more than the purchase price and asks you to wire some or all of the excess to a third party, often in a foreign country. The check turns out to be fraudulent.',

      'commonScams.unexpectedWindfall.title': 'Unexpected Windfall”',
      'commonScams.unexpectedWindfall.description':
        "You receive a letter or email stating that you have won a foreign lottery or are the beneficiary of someone's estate. The letter/email will say you have to pay a processing or transfer tax/fee before receiving the money, but a check will be enclosed to cover that fee. You are asked to deposit the check and wire the fee to a third party, often in a foreign country. The check turns out to be fraudulent.",

      'commonScams.mysteryShopping.title': 'Mystery Shopping',
      'commonScams.mysteryShopping.description':
        'You receive a letter or email informing you that you have been chosen to act as a mystery shopper, along with a check to deposit. You are told to use a portion of the funds to purchase merchandise, transfer a part of the funds to a third party, and keep the remainder. The check turns out to be fraudulent.',

      // organization list
      'organizationList.header': 'Organization List',
      'organizationList.subHeader':
        "Here's a list of all active organizations in your account",
      'organizationList.shareSuccess': 'Organization link copied to clipboard',
      'organizationList.menuItem.edit': 'Edit',
      'organizationList.menuItem.remove': 'Remove',
      'organizationList.deleteConfirm':
        'Are you sure you want to delete this organization?',
      'organizationList.userRole.user': 'Organization member',
      'organizationList.userRole.admin': 'Organization administrator',
      'organizationList.userRole.notInTheOrganization':
        'Not in this organization',
      'organizationList.sandboxLabel': 'Sandbox',
      'organizationList.externalLabel': 'External',
      'organizationList.disabledLabel': 'Disabled',
      'organizationList.addTile.label': 'Add organization',

      // organization form
      'organizationForm.create.header': 'Organization Form',
      'organizationForm.create.subHeader':
        'Fill in the details of the new organization',
      'organizationForm.create.sucscefull': 'Organization created successfully',
      'organizationForm.create.error': 'Error creating organization',
      'organizationForm.edit.header': 'Edit organization',
      'organizationForm.edit.subHeader': 'Edit organization details',
      'organizationForm.edit.sucscefull': 'Organization updated successfully',
      'organizationList.column.name': 'Name',
      'organizationList.column.description': 'Description',
      'organizationForm.edit.error': 'Error updating organization',
      'organizationForm.sandbox.label': 'Sandbox Mode',
      'organizationForm.sandbox.placeholder':
        'Enable sandbox mode for testing purposes',

      // payments list
      'payments.header': 'Payments',
      'payments.filters.placeholder': 'filter by paid and status',
      'payments.filters.selected': 'Selected',
      'payments.filters.paidTo': 'Paid to',
      'payments.filters.status': 'Status',
      'payments.subHeader': "Here's a list of all active payments",

      // payee list
      'payeeList.header': 'Payee List',
      'payeeList.subHeader':
        "Here's a list of all active payees in the account",
      'payeeList.menuItem.edit': 'Edit',
      'payeeList.menuItem.remove': 'Remove',
      'payeeList.deleteConfirm': 'Are you sure you want to delete this payee?',
      'payeeList.addTile.label': 'Add payee',
      'payeeList.column.id': 'Id',
      'payeeList.column.user': 'User',
      'payeeList.column.organization': 'Organization',
      'payeeList.column.nameOnCheck': 'Name On Check',
      'payeeList.column.email': 'Email',
      'payeeList.column.phone': 'Phone',
      'payeeList.column.address': 'Address',
      'payeeList.column.city': 'City',
      'payeeList.column.state': 'State',
      'payeeList.column.status': 'Status',
      'payeeList.column.zip': 'Zip',
      'payeeList.column.user.firstName': 'User First Name',
      'payeeList.column.user.lastName': 'User Last Name',
      'payeeList.column.user.email': 'User Email',
      'payeeList.column.createdOn': 'Created On',
      'payeeList.column.updatedOn': 'Updated On',
      'payeeList.column.payeeStatus.NotActive': 'Not active',
      'payeeList.column.payeeStatus.Deleted': 'Deleted',
      'payeeList.column.payeeStatus.Archive': 'Archive',
      'payeeList.column.payeeStatus.Active': 'Active',
      'payeeList.column.payeeStatus.Rejected': 'Rejected',
      'payeeList.column.payeeStatus.PendingForReview': 'Pending For Review',

      // payee form
      'payeeForm.create.header': 'Payee Form',
      'payeeForm.create.subHeader': 'Fill in the details of the new payee',
      'payeeForm.create.sucscefull': 'Payee created successfully',
      'payeeForm.create.error': 'Error creating payee',
      'payeeForm.edit.header': 'Edit payee',
      'payeeForm.edit.sucscefull': 'Payee updated successfully',
      'payeeForm.edit.subHeader': 'Edit payee details',
      'payeeForm.edit.error': 'Error updating payee',
      'payeeForm.ownedByCaller.title': 'Payee owner',
      'payeeForm.ownedByCaller.label':
        'Keep this payee under my account instead of the account behind its email',

      //bank list
      'bankList.header': 'Bank List',
      'bankList.subHeader': "Here's a list of all active banks in the account",
      'bankList.column.id': 'Id',
      'bankList.column.account': 'Account',
      'bankList.column.routing': 'Routing',
      'bankList.column.accountName': 'Account Name',
      'bankList.column.bankName': 'Bank Name',
      'bankList.column.companyName': 'Company Name',
      'bankList.column.address': 'Address',
      'bankList.column.city': 'City',
      'bankList.column.state': 'State',
      'bankList.column.zip': 'Zip',
      'bankList.column.createdOn': 'Created On',
      'bankList.column.updatedOn': 'Updated On',
      'bankList.deleteConfirm': 'Are you sure you want to delete this bank?',
      'bankList.actions.checkDesigner': 'Check designer',
      'bankList.actions.advancedCheckDesigner': 'Advanced designer',
      'bankList.actions.printBlankChecks': 'Print Blank Checks',

      // blank check
      'blankCheck.title': 'Print Blank Checks',
      'blankCheck.subTitle': 'Generate blank check stock for this bank account',
      'blankCheck.bankInfo': 'Bank account',
      'blankCheck.routing': 'Routing',
      'blankCheck.account': 'Account',
      'blankCheck.printType': 'Check type',
      'blankCheck.checkPaper': 'Check paper',
      'blankCheck.whitePaper': 'White paper',
      'blankCheck.checkNumberFrom': 'Check # From',
      'blankCheck.checkNumberTo': 'Check # To',
      'blankCheck.withSignature': 'With signature',
      'blankCheck.withoutSignature': 'Without signature',
      'blankCheck.checkCount': '{{count}} check(s) will be generated',
      'blankCheck.actions.preview': 'Preview',
      'blankCheck.actions.printAll': 'Print All',
      'blankCheck.history.title': 'Previously generated ranges',
      'blankCheck.errors.invalidCheckNumber':
        'Check number must be a whole number (0 or greater)',
      'blankCheck.errors.invalidRange': 'Enter a valid check number range',
      'blankCheck.errors.generateFailed': 'Failed to generate PDF',
      'blankCheck.errors.overlappingRange':
        'This range overlaps with a previously printed range',
      'blankCheck.success.generated':
        'Blank checks generated and sent to printer',

      // bank form
      'bankForm.create.header': 'Bank Form',
      'bankForm.create.subHeader': 'Fill in the details of the new bank',
      'bankForm.create.sucscefull': 'Bank created successfully',
      'bankForm.create.error': 'Error creating bank',
      'bankForm.edit.header': 'Edit bank',
      'bankForm.edit.sucscefull': 'Bank updated successfully',
      'bankForm.edit.subHeader': 'Edit bank details',
      'bankForm.edit.error': 'Error updating bank',

      // payment list
      'paymentList.header': 'Payment List',
      'paymentList.subHeader':
        "Here's a list of all active payment in the account",
      'paymentList.deleteConfirm':
        'Are you sure you want to delete this payment?',
      'paymentList.column.id': 'Id',
      'paymentList.column.amount': 'Amount',
      'paymentList.column.bank': 'Bank Name',
      'paymentList.column.checkNumber': 'Check Number',
      'paymentList.column.checkDate': 'Check Date',
      'paymentList.column.deliveryTime': 'Delivery Time',
      'paymentList.column.note': 'Note',
      'paymentList.column.memo': 'Memo',
      'paymentList.column.name': 'Name',
      'paymentList.column.company': 'Company',
      'paymentList.column.nameOnCheck': 'Name On Check',
      'paymentList.column.verifyCode': 'Verify Code',
      'paymentList.column.referenceId': 'Reference Id',
      'paymentList.column.email': 'Email',
      'paymentList.column.phone': 'Phone',
      'paymentList.column.address': 'Address',
      'paymentList.column.city': 'City',
      'paymentList.column.state': 'State',
      'paymentList.column.zip': 'Zip',
      'paymentList.column.kId': 'KId',
      'paymentList.column.status': 'Status',
      'paymentList.column.payee': 'Payee',
      'paymentList.column.createdOn': 'Created On',
      'paymentList.column.updatedOn': 'Updated On',
      'paymentList.column.payee.label':
        'Type here to select existing payee, or create new one',
      'paymentList.column.payee.helpText':
        'Leave this field empty, if you would like to create a new payee',
      'paymentList.cardActions.print': 'Print check',
      'paymentList.cardActions.printDisabled':
        'You can not print this check, it is was either already printed or not approved',
      'paymentList.actions.resend': 'Payment has been resent',
      'paymentList.actions.approve': 'Payment has been approved',
      'paymentList.actions.bulkResend': '{{count}} payment(s) have been resent',
      'paymentList.bulkResendTitle': 'Resend Selected Payments',
      'paymentList.bulkResendConfirm':
        'Are you sure you want to resend {{count}} selected payment(s)?',
      'paymentList.bulkResend': 'Resend Selected ({{count}})',
      'paymentList.approveTitle':
        'Are you sure you want to approve this payment?',
      'paymentList.approveConfirm':
        "To approve this payment, please enter the check number and click the 'Approve' button below.",
      'paymentList.jsonPreviewTitle': 'Payment Request JSON Preview',
      'paymentList.jsonPreviewInfo':
        'This is the JSON representation of the payment request.',
      'paymentList.emailStatus': 'Email Status',
      'paymentList.emailStatusInfo': 'Payment Email Statuses',
      'paymentList.emailStatusInfoTitle':
        'Check email delivery statuses. Please note that only for 30 days after sending email statuses are stored.',

      // user payments
      'userPaymentList.header': 'My Payments',
      'userPaymentList.subHeader': "Here's a list of all your active payments",
      'userPayment.checkDetails': 'Check details',
      'userPayment.requestPayment': 'Request payment',

      // audit list
      'auditList.header': 'Audit History List',
      'auditList.subHeader': "Here's a list of all audit records in the app",
      'auditList.column.entityId': 'Entity id',
      'auditList.column.eventType': 'Event Type',
      'auditList.column.entityType': 'Entity Type',
      'auditList.column.description': 'Description',
      'auditList.column.createdAt': 'Created at',
      'auditList.column.createdBy': 'Created by',
      'auditList.column.id': 'Id',

      'auditList.payeeDescription':
        'Name: {{name}}, Email: {{email}}, Phone: {{phone}}, Status: {{status}}',

      'auditList.paymentDescription':
        'Amount: {{amount}}, Payee: {{payee}}, Status: {{status}}',

      'auditList.bankDescription':
        'Bank Name: {{bankName}}, Account Name: {{accountName}}, Routing: {{routing}}, Account: {{account}}, Company Name: {{companyName}}',

      'auditList.userDescription':
        'Name: {{firstName}} {{lastName}}, Email: {{email}}',

      'auditList.settingsDescription': 'Settings updated: {{name}}',
      'auditList.apiClientTokenDescription':
        'Token: {{name}}, Enabled: {{isEnabled}}',
      'auditList.blankCheckDescription':
        'Bank: {{bankName}} | Checks: {{from}} – {{to}} | Signature: {{signature}} | Type: {{printType}}',

      'auditList.detail.title': 'Event Details',
      'auditList.detail.viewDetails': 'View Details',
      'auditList.detail.eventData': 'Event Data',
      'auditList.detail.setting': 'Setting',
      'auditList.detail.field': 'Field',
      'auditList.detail.name': 'Name',
      'auditList.detail.email': 'Email',
      'auditList.detail.phone': 'Phone',
      'auditList.detail.status': 'Status',
      'auditList.detail.amount': 'Amount',
      'auditList.detail.payee': 'Payee',
      'auditList.detail.bankName': 'Bank Name',
      'auditList.detail.accountName': 'Account Name',
      'auditList.detail.routing': 'Routing',
      'auditList.detail.account': 'Account',
      'auditList.detail.companyName': 'Company Name',
      'auditList.detail.firstName': 'First Name',
      'auditList.detail.lastName': 'Last Name',
      'auditList.detail.isEnabled': 'Enabled',
      'auditList.detail.checkFrom': 'Check # From',
      'auditList.detail.checkTo': 'Check # To',
      'auditList.detail.signature': 'Signature',
      'auditList.detail.printType': 'Print Type',
      'settings.Timezone': 'Timezone',
      'settings.NewECheckReceiveEmail': 'New ECheck Payment Email',
      'settings.ECheckPrintLimit': 'ECheck Print Limit',
      'settings.RedirectEmail': 'Redirect Email',
      'settings.AddedToOrganizationEmail': 'Added To Organization Email',

      'audit.status.PaymentCreated': 'Payment created',
      'audit.status.PaymentUpdated': 'Payment updated',
      'audit.status.PaymentDeleted': 'Payment deleted',
      'audit.status.PaymentVoided': 'Payment voided',
      'audit.status.PaymentSent': 'Payment sent',
      'audit.status.PaymentApproved': 'Payment approved',
      'audit.status.PaymentResented': 'Payment resent',

      'audit.status.PayeeCreated': 'Payee created',
      'audit.status.PayeeUpdated': 'Payee updated',
      'audit.status.PayeeDeleted': 'Payee deleted',

      'audit.status.BankCreated': 'Bank created',
      'audit.status.BankUpdated': 'Bank updated',
      'audit.status.BankDeleted': 'Bank deleted',

      'audit.status.UserCreated': 'User created',
      'audit.status.UserUpdated': 'User updated',
      'audit.status.UserDeleted': 'User deleted',
      'audit.status.UserAddedToOrganization': 'User added to organization',
      'audit.status.UserRemovedFromOrganization':
        'User removed from organization',
      'audit.status.UserRegistered': 'User registered',
      'audit.status.UserUpdatedOwnProfile': 'User updated own profile',
      'audit.status.UserRightsUpdated': 'User rights updated',

      'audit.status.SettingsCreated': 'Settings created',
      'audit.status.SettingsUpdated': 'Settings updated',

      'audit.status.ApiClientTokenCreated': 'API token created',
      'audit.status.ApiClientTokenEnabled': 'API token enabled',
      'audit.status.ApiClientTokenDisabled': 'API token disabled',
      'audit.status.ApiClientTokenDeleted': 'API token deleted',

      'audit.status.BlankCheckGenerated': 'Blank check printed',

      'audit.status.BillingPlanChanged': 'Plan changed',
      'audit.status.BillingPlanCanceled': 'Subscription canceled',
      'audit.status.BillingSubscriptionStatusChanged':
        'Subscription status changed',
      'audit.status.BillingCheckPurchaseStarted': 'Check purchase started',
      'audit.status.BillingChecksPurchased': 'Checks purchased',
      'audit.status.BillingCreditUpdated': 'Entitlement updated',

      'audit.entityType.Payment': 'Payment',
      'audit.entityType.Payee': 'Payee',
      'audit.entityType.Bank': 'Bank',
      'audit.entityType.User': 'User',
      'audit.entityType.Settings': 'Settings',
      'audit.entityType.ApiClientToken': 'API Token',
      'audit.entityType.BlankCheckRange': 'Blank Check',
      'audit.entityType.Organization': 'Organization',
      'audit.entityType.Billing': 'Usage & Billing',

      // payment request form
      'paymentRequestForm.create.header': 'Payment Request Form',
      'paymentRequestForm.create.subHeader':
        'Fill in the details of the new payment request',
      'paymentRequestForm.edit.sucscefull':
        'Payment request created successfully',
      'paymentRequestForm.edit.error': 'Error creating payment request',
      'paymentRequestForm.helpTex':
        'Select organization first to create payment request',

      // bank form
      'paymentForm.create.header': 'Payment Form',
      'paymentForm.create.subHeader': 'Create of the new payment',
      'paymentForm.create.sucscefull': 'Payment created successfully',
      'paymentForm.create.error': 'Error creating payment',
      'paymentForm.edit.header': 'Edit payment',
      'paymentForm.edit.sucscefull': 'Payment updated successfully',
      'paymentForm.edit.subHeader': 'Edit payment details',
      'paymentForm.edit.error': 'Error updating payment',

      // user list
      'membersList.header': 'Members List',
      'membersList.subHeader':
        "Here's a list of all members users in the organization",
      'membersList.deleteConfirm': 'Are you sure you want to delete this user?',
      'membersList.column.avatar': 'Avatar',
      'membersList.column.firstName': 'First Name',
      'membersList.column.lastName': 'Last Name',
      'membersList.column.email': 'Email',
      'membersList.column.userType': 'User Type',
      'membersList.column.userStatus': 'Status',
      'membersList.userStatus.Active': 'Active',
      'membersList.userStatus.Inactive': 'Inactive',
      'membersList.userStatus.Deleted': 'Deleted',
      'membersList.userStatus.NotRegistered': 'Not registered',
      'membersList.column.userRights': 'User Rights',
      'membersList.column.phone': 'Phone',
      'membersList.removeFromOrganization': 'Remove',
      'membersList.userRights.ManageOrganization': 'Manage Organization',
      'membersList.userRights.MemberAdministration': 'Member Administration',
      'membersList.userRights.BankAccess': 'Bank Access',
      'membersList.userRights.PaymentProcessing': 'Payment Processing',
      'membersList.userRights.PayeeDirectory': 'Payee Directory',
      'membersList.userRights.ViewUserActivity': 'View User Activity',
      'membersList.userRights.SettingsAccess': 'Settings Access',
      'membersList.userRights.ApiDocumentationAccess':
        'API Documentation Access',
      'membersList.userRights.AuditLogsAccess': 'Audit Logs Access',
      'membersList.userRights.SuperAdmin': 'Super Admin',
      'superAdmin.header': 'Super Administration',
      'superAdmin.subHeader':
        'All organizations — click a row to view statistics and users',
      'superAdmin.empty': 'No organizations found',
      'superAdmin.column.avatar': 'Avatar',
      'superAdmin.column.name': 'Name',
      'superAdmin.column.description': 'Description',
      'superAdmin.column.type': 'Type',
      'superAdmin.type.live': 'Live',
      'superAdmin.type.sandbox': 'Sandbox',
      'superAdmin.type.disabled': 'Disabled',

      // Organization detail — tabs
      'superAdmin.tab.statistics': 'Statistics',
      'superAdmin.tab.users': 'Users',
      'superAdmin.tab.usage': 'Usage',

      // Organization detail — statistics tab
      'superAdmin.stats.period.day': 'Last 24h',
      'superAdmin.stats.period.month': 'Last 30 days',
      'superAdmin.stats.period.year': 'Last 12 months',
      'superAdmin.stats.periodToggle.day': 'Day',
      'superAdmin.stats.periodToggle.month': 'Month',
      'superAdmin.stats.periodToggle.year': 'Year',
      'superAdmin.stats.checksCreated': 'Checks Created',
      'superAdmin.stats.checksPrinted': 'Checks Printed',
      'superAdmin.stats.moneyIssued': 'Money Issued',
      'superAdmin.stats.paymentStatus': 'Payment Status',
      'superAdmin.stats.noData': 'No data for this period',

      // Organization detail — users tab
      'superAdmin.users.empty': 'No users found in this organization',

      // Organization detail — usage tab
      'superAdmin.usage.plan.header': 'Plan & credits',
      'superAdmin.usage.plan.combinedHint':
        'The plan sets the monthly allowance and features. Turn on a credit grant to override it — the plan stays on the record so billing is not cut off.',
      'superAdmin.usage.plan.planField': 'Plan',
      'superAdmin.usage.plan.planIncludes':
        'Entitlements, seeded from the plan and adjustable for this organization',
      'superAdmin.usage.plan.maxBanks': 'Bank accounts',
      'superAdmin.usage.plan.maxBanksHelper': '-1 = unlimited',
      'superAdmin.usage.plan.grantField': 'Credit grant',
      'superAdmin.usage.plan.grantNone': 'None — use the plan',
      'superAdmin.usage.plan.grantMonthly': 'Monthly cap',
      'superAdmin.usage.plan.grantLifetime': 'Lifetime credits',
      'superAdmin.usage.plan.grantUnlimited': 'Unlimited',
      'superAdmin.usage.plan.savePlanOnly': 'Save plan',
      'superAdmin.usage.plan.saved': 'Saved',
      'superAdmin.usage.plan.creditsToAdd': 'Credits to add',
      'superAdmin.usage.plan.monthlyLimit': 'Monthly limit',
      'superAdmin.usage.plan.from': 'From',
      'superAdmin.usage.plan.till': 'Till',
      'superAdmin.usage.plan.addCredits': 'Add credits',
      'superAdmin.usage.plan.savePlan': 'Save plan',
      'superAdmin.usage.plan.saveUnlimited': 'Save unlimited',
      'superAdmin.usage.plan.current': 'Current',
      'superAdmin.usage.plan.allowance': 'Allowance',
      'superAdmin.usage.plan.used': 'Used',
      'superAdmin.usage.plan.remaining': 'Remaining',
      'superAdmin.usage.plan.limit': 'Limit',
      'superAdmin.usage.plan.status': 'Status',
      'superAdmin.usage.plan.typeLifetime': 'Lifetime',
      'superAdmin.usage.plan.typeMonthly': 'Monthly',
      'superAdmin.usage.plan.typeUnlimited': 'Unlimited',
      'superAdmin.usage.plan.unlimitedValue': 'No limit',
      'superAdmin.usage.plan.creditsValue': '{{count}} credits',
      'superAdmin.usage.plan.monthlyValue': '{{count}}/mo',
      'superAdmin.usage.plan.expired': 'Expired',
      'superAdmin.usage.plan.active': 'Active',
      'superAdmin.usage.plan.inactive': 'Inactive',
      'superAdmin.usage.lifetimeHeader': 'Lifetime credits',
      'superAdmin.usage.monthHeader': 'Current month usage',
      'superAdmin.usage.unlimitedHeader': 'Unlimited credits',
      'superAdmin.usage.unlimitedValue': 'Unlimited',
      'superAdmin.usage.unlimitedHint':
        'This organization is not metered — checks are never blocked for lack of credit.',
      'superAdmin.usage.unlimitedUsed':
        '{{count}} checks issued since unlimited was turned on',
      'superAdmin.usage.creditsUnit': 'credits',
      'superAdmin.usage.noCreditsRemaining': 'No lifetime credits remaining',
      'superAdmin.usage.creditsRemainingHint':
        'Lifetime credits remaining (does not reset)',
      'superAdmin.usage.lifetimeBreakdown':
        '{{allowance}} allowance − {{used}} used',
      'superAdmin.usage.lifetimeCountedSince':
        'Allowance and usage are measured from the latest credit change on {{date}}. Blank check prints do not consume credits.',
      'superAdmin.usage.checksRemaining':
        '{{count}} checks remaining this month',
      'superAdmin.usage.access.header': 'Organization access',
      'superAdmin.usage.access.disabledHint':
        'This organization is disabled. Users cannot create new checks.',
      'superAdmin.usage.access.activeHint':
        'This organization is active. Disable it to prevent users from creating checks.',
      'superAdmin.usage.access.enable': 'Enable org',
      'superAdmin.usage.access.disable': 'Disable org',
      'userForm.create.header': 'User Form',
      'userForm.create.subHeader': 'Fill in the details of the new user',
      'userForm.create.sucscefull': 'User created successfully',
      'userForm.create.error': 'Error creating user',
      'userForm.edit.header': 'Edit user',
      'userForm.edit.sucscefull': 'User updated successfully',
      'userForm.edit.subHeader': 'Edit user details',
      'userForm.edit.error': 'Error updating user',
      'userForm.load.error': 'Could not load this user',

      'userFor.invite.header': 'Invite User',
      'userFor.invite.subHeader':
        'Fill in the details of the new user to invite them to the organization',
      'userForm.editRight.header': 'Edit user rights',
      'userForm.editRight.subHeader': 'Edit user rights in the organization',
      'userForm.helpText':
        'By default, the admin user is granted all rights, while a simple user can only read their own checks and request them.',

      // General Settings
      'settings.tab': 'General',

      'settings.generalSettings.ECheckPrintLimit': 'ECheck Print Limit',
      'settings.generalSettings.ECheckPrintLimit.label':
        'The maximum number of times an e-check can be printed',
      'settings.generalSettings.RedirectEmail': 'Redirect Email',
      'settings.generalSettings.RedirectEmail.label':
        'Email address for redirecting notifications in sandbox mode',
      'settings.generalSettings.RedirectEmail.error':
        'Please enter a valid email address',

      // Usage & billing
      'billing.tab': 'Usage & billing',
      'billing.header': 'Usage & billing',
      'billing.loadFailed': 'Could not load billing information.',
      'billing.needsManageRight':
        'You need the Manage Organization right to change the plan or buy checks.',
      'billing.stripeUnavailable':
        'Online payment is not configured in this environment.',

      'billing.usage.monthHeader': 'Used this month',
      'billing.usage.packHeader': 'Purchased checks left',
      'billing.usage.totalRemaining': '{{count}} checks remaining in total',
      'billing.usage.outOfChecks': 'Out of checks',
      'billing.usage.drawOrder':
        'Checks come out of the monthly plan allowance first; purchased checks cover anything beyond it and never expire.',
      'billing.usage.banksOfLimit': '{{count}} of {{limit}} bank accounts',
      'billing.usage.banksUnlimited': '{{count}} bank accounts (unlimited)',
      'billing.usage.unlimitedValue': 'Unlimited',
      'billing.usage.unlimitedHint':
        'This organization is not metered — {{count}} checks issued since unlimited was turned on.',
      'billing.usage.grantHint':
        'Your administrator has set this allowance directly, so it overrides the plan below.',

      'billing.subscription.onPlan': '{{plan}} plan',
      'billing.subscription.noPlanHeader': 'No subscription',
      'billing.subscription.noPlan': 'Not subscribed',
      'billing.subscription.freeHint':
        'This organization is on the free plan. Pick a plan below to raise the monthly allowance.',
      'billing.subscription.renewsOn': 'Renews on {{date}}',
      'billing.subscription.endsOn': 'Ends on {{date}}',
      'billing.subscription.status.active': 'Active',
      'billing.subscription.status.pastDue': 'Payment failed',
      'billing.subscription.status.canceled': 'Canceled',
      'billing.subscription.status.incomplete': 'Incomplete',
      'billing.subscription.manage': 'Manage billing',
      'billing.subscription.cancel': 'Cancel plan',
      'billing.subscription.canceled':
        'The plan will not renew at the end of the current period.',
      'billing.subscription.cancelFailed': 'Could not cancel the plan.',

      'billing.featureLocked.header': 'Not included in your plan',
      'billing.featureLocked.description':
        'This feature is part of a higher plan. Upgrade to unlock it for your organization.',
      'billing.featureLocked.action': 'View plans',
      'billing.featureLocked.descriptionNoBilling':
        'This feature is not included in your plan. Contact support to enable it for your organization.',

      'billing.plan.header': 'Plans',
      'billing.plan.change': 'Change plan',
      'billing.plan.current': 'Current',
      'billing.plan.currentPlanButton': 'Current plan',
      'billing.plan.choose': 'Switch to {{plan}}',
      'billing.plan.changed': 'Plan updated.',
      'billing.plan.contactSales': 'Contact Sales',
      'billing.plan.salesSubject': 'Enquiry about the {{plan}} plan',
      'billing.plan.notConfigured':
        'Not available for online purchase yet — contact support.',
      'billing.plan.unlimitedLocked':
        'This organization has unlimited checks, so plans are locked. Your administrator has to lift the unlimited grant before a plan can be chosen.',
      'billing.plan.priceFree': 'Free',
      'billing.plan.priceCustom': 'Custom',
      'billing.plan.priceMonthly': '{{price}}/month',
      'billing.plan.includedPerMonth': '{{count}} checks per month',
      'billing.plan.includedPerBank': '{{count}} checks per bank account',
      'billing.plan.extraEach': 'Extra checks {{price}} each',
      'billing.plan.extraPackPricing': 'Extra checks at pack pricing',
      'billing.plan.extraNegotiated': 'Extra checks negotiated',
      'billing.plan.banks': '{{count}} bank accounts',
      'billing.plan.banksUnlimited': 'Unlimited bank accounts',
      'billing.plan.feature.checkDesigner': 'Advanced check designer',
      'billing.plan.feature.emailTemplates': 'Custom email templates',
      'billing.plan.feature.apiAccess': 'API access',
      'billing.plan.feature.prioritySupport': 'Priority support',
      'billing.plan.feature.badge': 'EasyECheck badge on checks',

      'billing.topUp.open': 'Top up checks',
      'billing.topUp.header': 'Top up your check balance',
      'billing.topUp.hint':
        'Purchased checks are added to the organization and are used once the monthly plan allowance runs out.',
      'billing.topUp.quantity': 'Checks',
      'billing.topUp.quantityInvalid':
        'Enter a whole number of checks greater than 0.',
      'billing.topUp.total': 'Total',
      'billing.topUp.totalValue': '{{total}}',
      'billing.topUp.perCheck': '{{price}} per check',
      'billing.topUp.perCheckValue': '{{price}}',
      'billing.topUp.buy': 'Buy checks',
      'billing.topUp.contactSales': 'Contact Sales',
      'billing.topUp.salesSubject': 'Quote for {{count}} checks',
      'billing.topUp.tableHeader': 'Pack pricing',
      'billing.topUp.column.quantity': 'Quantity',
      'billing.topUp.column.pricePerCheck': 'Price per check',
      'billing.topUp.range': '{{min}}–{{max}}',
      'billing.topUp.rangeOpen': '{{min}}+',
      'billing.topUp.salesNote':
        'Purchases above {{max}} checks are handled by Sales.',

      'billing.history.header': 'Payment history',
      'billing.history.empty': 'Nothing has been billed yet.',
      'billing.history.column.description': 'Description',
      'billing.history.column.receipt': 'Receipt',
      'billing.history.packDescription': '{{count}} checks (pack)',
      'billing.history.planDescription': 'Plan — {{description}}',
      'billing.history.planPeriod': '{{from}} – {{to}}',
      'billing.history.view': 'View',
      'billing.purchase.column.date': 'Date',
      'billing.purchase.column.checks': 'Checks',
      'billing.purchase.column.pricePerCheck': 'Price per check',
      'billing.purchase.column.total': 'Total',
      'billing.purchase.column.status': 'Status',
      'billing.purchase.status.paid': 'Paid',
      'billing.purchase.status.pending': 'Pending',
      'billing.purchase.status.failed': 'Failed',

      'billing.checkout.completed':
        'Payment received. Your balance updates as soon as Stripe confirms it.',
      'billing.checkout.canceled': 'Checkout was canceled.',
      'billing.checkout.failed': 'Could not start checkout.',

      // Billing catalogue — super admin
      'billingCatalogue.header': 'Billing catalogue',
      'billingCatalogue.subHeader':
        'Plans and pack pricing every organization is billed against',
      'billingCatalogue.active': 'Active',
      'billingCatalogue.retired': 'Retired',
      'billingCatalogue.notSet': 'Not set',
      'billingCatalogue.edit': 'Edit',
      'billingCatalogue.retire': 'Retire',
      'billingCatalogue.save': 'Save',
      'billingCatalogue.cancel': 'Cancel',
      'billingCatalogue.saved': 'Saved.',
      'billingCatalogue.saveFailed': 'Could not save.',

      'billingCatalogue.column.plan': 'Plan',
      'billingCatalogue.column.price': 'Price',
      'billingCatalogue.column.included': 'Included checks',
      'billingCatalogue.column.extra': 'Extra check',
      'billingCatalogue.column.banks': 'Bank accounts',
      'billingCatalogue.column.stripePrice': 'Stripe price id',
      'billingCatalogue.column.status': 'Status',
      'billingCatalogue.column.minQuantity': 'From',
      'billingCatalogue.column.maxQuantity': 'To',
      'billingCatalogue.column.pricePerCheck': 'Price per check',

      'billingCatalogue.plan.header': 'Plans',
      'billingCatalogue.plan.hint':
        'Retiring a plan hides it from customers; organizations already on it keep their allowance.',
      'billingCatalogue.plan.add': 'Add plan',
      'billingCatalogue.plan.editing': 'Editing {{plan}}',
      'billingCatalogue.plan.creating': 'New plan',

      'billingCatalogue.tier.header': 'Check pack pricing',
      'billingCatalogue.tier.hint':
        'Quantities above {{max}} are refused at checkout and sent to Sales.',
      'billingCatalogue.tier.add': 'Add tier',
      'billingCatalogue.tier.editing': 'Editing tier',
      'billingCatalogue.tier.creating': 'New tier',
      'billingCatalogue.tier.openEnded': 'No limit',
      'billingCatalogue.tier.maxHelper': 'Leave blank for no upper limit',

      'billingCatalogue.field.code': 'Code',
      'billingCatalogue.field.name': 'Name',
      'billingCatalogue.field.description': 'Description',
      'billingCatalogue.field.monthlyPrice': 'Price / month',
      'billingCatalogue.field.includedChecks': 'Included checks',
      'billingCatalogue.field.includedChecksPerBank': 'Included per bank',
      'billingCatalogue.field.extraCheckPrice': 'Extra check price',
      'billingCatalogue.field.maxBankAccounts': 'Max banks (-1 = unlimited)',
      'billingCatalogue.field.sortOrder': 'Sort order',
      'billingCatalogue.field.stripePriceId': 'Stripe price id',
      'billingCatalogue.field.showBadge': 'Show badge',
      'billingCatalogue.field.hasCheckDesigner': 'Advanced check designer',
      'billingCatalogue.field.hasCustomEmailTemplates': 'Email templates',
      'billingCatalogue.field.hasApiAccess': 'API access',
      'billingCatalogue.field.hasPrioritySupport': 'Priority support',
      'billingCatalogue.field.isCustom': 'Sales only',
      'billingCatalogue.field.isActive': 'Active',

      // email designer
      'emailDesigner.tab': 'Email designer',
      'emailDesigner.tabs.edit': 'Edit',
      'emailDesigner.panel.text': 'Content',

      'emailDesigner.panel.spacer': 'Spacer block',
      'emailDesigner.panel.image.sourceUrl': 'Source URL',
      'emailDesigner.panel.image.altText': 'Alt Text',
      'emailDesigner.panel.image.clickUrl': 'Click through URL',
      'emailDesigner.panel.image.width': 'Width',
      'emailDesigner.panel.image.height': 'Height',
      'emailDesigner.panel.image.alignment': 'Alignment',
      'emailDesigner.panel.html': 'Content',
      'emailDesigner.panel.heading': 'Heading block',
      'emailDesigner.panel.heading.level': 'Level',
      'emailDesigner.panel.emailLayout': 'Global',
      'emailDesigner.panel.emailLayout.backdropColor': 'Backdrop color',
      'emailDesigner.panel.emailLayout.canvasColor': 'Canvas color',
      'emailDesigner.panel.emailLayout.canvasBorderColor':
        'Canvas border color',
      'emailDesigner.panel.emailLayout.canvasBorderRadius':
        'Canvas border radius',
      'emailDesigner.panel.emailLayout.fontFamily': 'Font family',
      'emailDesigner.panel.emailLayout.textColor': 'Text color',
      'emailDesigner.panel.dividerBlock': 'Divider block',
      'emailDesigner.panel.dividerBlock.color': 'Color',
      'emailDesigner.panel.dividerBlock.height': 'Height',
      'emailDesigner.panel.containerBlock': 'Container block',
      'emailDesigner.panel.columnsContainer': 'Number of columns',
      'emailDesigner.panel.columnsContainer.columnsGap': 'Columns gap',
      'emailDesigner.panel.columnsContainer.alignment': 'Alignment',
      'emailDesigner.panel.button': 'Button block',
      'emailDesigner.panel.button.text': 'Text',
      'emailDesigner.panel.button.url': 'Url',
      'emailDesigner.panel.button.width': 'Width',
      'emailDesigner.panel.button.width.full': 'Full',
      'emailDesigner.panel.button.width.auto': 'Auto',
      'emailDesigner.panel.button.size': 'Size',
      'emailDesigner.panel.button.style': 'Style',
      'emailDesigner.panel.button.style.rectangle': 'Rectangle',
      'emailDesigner.panel.button.style.rounded': 'Rounded',
      'emailDesigner.panel.button.style.pill': 'Pill',
      'emailDesigner.panel.button.style.textColor': 'Text color',
      'emailDesigner.panel.button.style.buttonColor': 'Button color',
      'emailDesigner.tabs.preview': 'Preview',
      'emailDesigner.actions.exportTemplate': 'Export template',
      'emailDesigner.actions.saveTemplate': 'Save template',
      'emailDesigner.actions.importTemplate': 'Import template',
      'emailDesigner.import.selectFileTitle': 'Import Email Template',
      'emailDesigner.import.selectFile': 'Import Email Template file (.json)',
      'emailDesigner.import.senseful': 'Document was imported successfully',
      'emailDesigner.import.fromOrganization': 'Or import from organization',
      'emailDesigner.import.buttonFromOrganization': 'Import from organization',
      'emailDesigner.save.senseful': 'Document was saved successfully',

      'emailDesigner.template.NewECheckReceiveEmail': 'ECheck Template',
      'emailDesigner.template.AddedToOrganizationEmail':
        'Added to organization',
      'emailDesigner.actions.clearTemplate': 'Clear Template',
      'emailDesigner.actions.help': 'Design helper',
      'emailDesigner.error.invalidFile':
        'Cannot import this file, please check format',
      'emailDesigner.help.header': 'Design Helper',
      'emailDesigner.help.subHeader':
        'Here you can get information about email template keywords',

      // check designer keywords help
      'checkDesigner.help.keywords.title': 'Keywords',
      'checkDesigner.help.keywords.description': 'Description',
      'checkDesigner.help.description':
        'You can use the following keywords in the template to display the actual data',
      'checkDesigner.help.keywords.name_on_check':
        'The name of the user who receives the check',
      'checkDesigner.help.keywords.organization':
        'The name of the organization that sends the check',
      'checkDesigner.help.keywords.organization_invite':
        'The name of the organization that invites the user',
      'checkDesigner.help.keywords.amount': 'The amount of the transaction',
      'checkDesigner.help.keywords.link': 'The link to the print check page',
      'checkDesigner.help.keywords.link_invite':
        'The link website to join the organization',
      'checkDesigner.help.keywords.verify': 'The link to the verify check page',
      'checkDesigner.help.keywords.name':
        ' The name of the user who was added to the organization',

      'simpleCheckDesigners.advancedDesigner': 'Advanced designer',
      'simpleCheckDesigner.header': 'Simple Check Designer',
      'simpleCheckDesigner.subHeader':
        'Here you can design your check template',
      'simpleCheckDesigner.success': 'Template was successfully saved',

      // check designer
      'checkDesigner.actions.downloadTemplate': 'Download',
      'checkDesigner.actions.loadTemplate': 'Load Template',
      'checkDesigner.actions.changePDF': 'Change PDF',
      'checkDesigner.actions.previewPDF': 'Preview PDF',
      'checkDesigner.actions.saveComplete': 'Template was successfully saved',
      'checkDesigner.actions.saveTemplate': 'Save Template',
      'checkDesigner.actions.addField': 'Add Field',

      // signature pad
      'signaturePad.size': 'Size',
      'signaturePad.smoothing': 'Smoothing',
      'signaturePad.thinning': 'Thinning',
      'signaturePad.streamline': 'Streamline',
      'signaturePad.resetSettings': 'Reset settings',
      'signaturePad.clear': 'Clear',
      'signaturePad.save': 'Save',
      'signaturePad.open': 'Open file for signature',

      //check verification
      'verifyCheck.header': 'Check Verification',
      'verifyCheck.result': 'Verification Result',
      'verifyCheck.subHeader':
        'To verify the check, please enter the  verification code',
      'verifyCheck.code': 'verification code',
      'verifyCheck.verify': 'Verify Check',

      'verifyCheck.checkValid': 'Check is not valid',
      'verifyCheck.checkValidText':
        'The check you are looking with this <strong>{{code}}</strong> code, is not valid',
      'verifyCheck.returnBack': 'Return back to search',

      // legal sections

      // api docs tabs
      'apiDocs.tab.documentation': 'Documentation',
      'apiDocs.tab.tokens': 'API Client Tokens',

      // api client tokens
      'apiTokens.header': 'API Client Tokens',
      'apiTokens.subHeader':
        'Manage API tokens for programmatic access to this organization',
      'apiTokens.column.name': 'Name',
      'apiTokens.column.token': 'Token',
      'apiTokens.column.status': 'Status',
      'apiTokens.column.expiresAt': 'Expires At',
      'apiTokens.column.lastUsedAt': 'Last Used',
      'apiTokens.column.createdOn': 'Created On',
      'apiTokens.status.active': 'Active',
      'apiTokens.status.disabled': 'Disabled',
      'apiTokens.actions.enable': 'Enable',
      'apiTokens.actions.disable': 'Disable',
      'apiTokens.modal.create.title': 'Create API Token',
      'apiTokens.modal.create.name': 'Token Name',
      'apiTokens.modal.create.expiresAt': 'Expires At (optional)',
      'apiTokens.modal.create.expiresAtHint':
        'Leave empty for a non-expiring token',
      'apiTokens.modal.create.submit': 'Create Token',
      'apiTokens.modal.created.title': 'Token Created',
      'apiTokens.modal.created.warning':
        'Copy this token now — it will not be shown again.',
      'apiTokens.modal.created.copyInstruction':
        'Use this token in the X-API-Token request header.',
      'apiTokens.error.createFailed': 'Failed to create token.',

      // payee export modal
      'payeeExportModal.title': 'Export Payees',
      'payeeExportModal.subTitle':
        'Configure columns, format, and record limit',
      'payeeExportModal.group.contact': 'Contact Info',
      'payeeExportModal.group.address': 'Address',
      'payeeExportModal.group.audit': 'Audit',
      'payeeExportModal.column.isDisabled': 'Is Disabled',

      // export modal
      'exportModal.title': 'Export Payments',
      'exportModal.subTitle': 'Configure columns, format, and record limit',
      'exportModal.format': 'File Format',
      'exportModal.columns': 'Columns',
      'exportModal.selectAll': 'Select All',
      'exportModal.deselectAll': 'Deselect All',
      'exportModal.recordLimit': 'Record Limit',
      'exportModal.pageSize.all': 'All (max 5,000)',
      'exportModal.includeTotals': 'Include totals row (sum of Amount)',
      'exportModal.exportButton': 'Export',
      'exportModal.group.paymentInfo': 'Payment Info',
      'exportModal.group.audit': 'Audit',
      'exportModal.column.eCheck': 'E-Check',
      'exportModal.column.ePrintCount': 'Print Count',

      // auth
      'auth.redirecting': 'Redirecting to login page...',
      'auth.completingSignIn': 'Completing sign-in...',
      'auth.failedSignIn': 'Failed to authenticate. Please try again.',
      'auth.noAuthTokenReceived': 'No authentication token received',
      'auth.failedToAuthenticate': 'Failed to authenticate user',
    },
  },
  uk: {
    translation: {},
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    resources,
    debug: process.env.I18N_DEBUG === 'true',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
